/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswersResultIdResults } from './answersResultIdResults';
import { Qualifier } from './qualifier';


export interface AnswersResult { 
    summaryResult?: AnswersResult.SummaryResultEnum;
    qualifiers?: Array<Qualifier>;
    idResults?: AnswersResultIdResults;
}
export namespace AnswersResult {
    export type SummaryResultEnum = 'Success' | 'Failure';
    export const SummaryResultEnum = {
        Success: 'Success' as SummaryResultEnum,
        Failure: 'Failure' as SummaryResultEnum
    };
}


